import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";

export function QuestionizerResultSummary(){
    const plz = useQuestionizerStore((state) => state.plz);
    const gemeinde = useQuestionizerStore((state) => state.gemeinde);
    const gewerk_labels = useQuestionizerStore((state) => state.getGewerkLabels());
    const gebaeude = useQuestionizerStore((state) => state.gebaeude);
    const typ = useQuestionizerStore((state) => state.typ);
    const baujahr = useQuestionizerStore((state) => state.baujahr);
    const antragsteller = useQuestionizerStore((state) => state.antragsteller);
    const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
	const L = useQuestionizerStore((state) => state.L);

    const _antragsteller = (antragsteller?.length == 1) ? antragsteller[0] : antragsteller_detail;
    
	return (
		  <div className="mb-8"  aria-describedby="result-summary">

			<p id="result-summary" className="mb-8">{L("result-summary-description")}</p>

			<section className="summary">
			  <h2 className="summary__title">{L("result-summary-title")}</h2>

			  {/* Barrierefreie Tabelle */}
			  <table className="summary__table" style={{ borderCollapse: "collapse" }}>
				<caption className="sr-only">{L("result-summary-title")}</caption>

				<tbody>
				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  {L('input_result_massnahmen') || 'Gewählte Maßnahmen'}
					</th>
					<td>{gewerk_labels.map(l => L(l) || l).join(", ")}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  {L('input_result_antragsteller') || 'Antragsteller'}
					</th>
					<td>{L(FDWAntragsteller[_antragsteller!]) || FDWAntragsteller[_antragsteller!]}</td>
				  </tr>

				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  {L('input_result_ort') || 'Ort'}
					</th>
					<td>{plz} {gemeinde?.gemeinde_name}</td>
				  </tr>

				{gebaeude && (
				<tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					{L('input_result_gebaeude') || 'Gebäude'}
					</th>
					<td>{L(gebaeude) || gebaeude}</td>
				</tr>
				)}

				{typ && (
				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  {L('input_result_typ') || 'Typ'}
					</th>
					<td>{L(typ) || typ}</td>
				  </tr>
				)}

				{baujahr && (
				  <tr>
					<th scope="row" style={{ textAlign: "left", verticalAlign: "top" }}>
					  {L('input_result_baujahr') || 'Baujahr'}
					</th>
					<td>{baujahr}</td>
				  </tr>
				)}
				
				</tbody>
			  </table>
			</section>
		  </div>
		);

 
  }